import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from '@angular/router';
import { GrupoService } from 'src/app/data-access/grupo.service';
import { UsuarioService } from 'src/app/data-access/usuario.service'
import { TipoUsuarioService } from 'src/app/data-access/tipoUsuario.service'

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styles: [
  ]
})
export class MenuAdminComponent implements OnInit {

  constructor(
    private router: Router,
    private usuarioService: UsuarioService,
    private grupoService: GrupoService,
    private tipoUsuarioService: TipoUsuarioService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public modal: NgbModal,
    private activatedRoute: ActivatedRoute
  ) {
    this.getSitio(1);
    if(!this.usuarioService.adm()) this.router.navigate(['/menu']);
    /*
    let usr = {
      apMat: "ARGUELLO",
      apPat: "VARGAS",
      cuenta: "6714",
      departamento: "Dirección de Planeación y Evaluación Institucionales",
      email: "osvaldo.vargas@ibero.mx",
      nivel: "106000",
      nombre: "JOSE PEDRO OSVALDO",
      nombreCompleto: "JOSE PEDRO OSVALDO VARGAS ARGUELLO"
      }

    this.usuarioService.addUser(usr);
     
    localStorage.setItem('valido', '0');
    this.getSitio(undefined);
    let noredirect = localStorage.getItem('noredirect');
    let cov19rec = localStorage.getItem('cov19rec');
    
    if(noredirect != 'true'){
      if(cov19rec == 'true'){
        this.router.navigate(['/login']);
      }
      else{
        localStorage.setItem('user', '');        
      }
    }
    */
    /*
    this.activatedRoute.params.subscribe(params => {
      //this.sitio = params['id'];
      this.getSitio(this.sitio);
      //this.sitio = this.usuarioService.getSitio();
    
      let noredirect = localStorage.getItem('noredirect');
      let cov19rec = localStorage.getItem('cov19rec');
      
      if(noredirect != 'true'){
        if(cov19rec == 'true'){
          this.router.navigate(['/login']);
        }
        else{
          localStorage.setItem('user', '');        
        }
      }

      //this.getEncuesta(this.idEncuesta);
    });
    */
  }

  selectedUser = 2;
  isSelected = false;
  onSelect(index): void {
    this.selectedUser = index;
  }

  //UsuariosLista;
  //GrupoLista;
  ngOnInit(): void {
    this.selectedUser = 2;
    //Validamos si hay algún grupo seleccionado
    let user = localStorage.getItem('usuarioGrupo');
    //console.log(user);
    if (user != undefined) {
      this.selectedUser = Number(user);
    }
    this.getGrupoLista();
    //this.getTipoUsuario();
  }

  Grupo;
  GrupoLista;
  getGrupoLista() {
    this.spinner.show();
    /*
    this.GrupoLista = [
    {estatus: true,  icono: "user", idGrupo: 1, idPerfil: 2, nombre: "Usuarios"},
    {estatus: true,  icono: "user-tag", idGrupo: 2, idPerfil: 2, nombre: "Roles"},
    {estatus: true,  icono: "book-open", idGrupo: 3, idPerfil: 2, nombre: "Solicitudes"},
    {estatus: true,  icono: "tag", idGrupo: 4, idPerfil: 2, nombre: "Tipo de Espacio"},
    {estatus: true,  icono: "school", idGrupo: 5, idPerfil: 2, nombre: "Espacios"},
    {estatus: true,  icono: "headphones", idGrupo: 6, idPerfil: 2, nombre: "Equipos"},
    {estatus: true,  icono: "calendar", idGrupo: 7, idPerfil: 2, nombre: "Días Inhábiles"}];
    this.spinner.hide();
    */
    this.grupoService.getGrupo().toPromise()
      .then(data => {
        this.Grupo = data;
        this.GrupoLista = this.Grupo.filter(x => x.idPerfil === 2);
        this.spinner.hide();
        //console.log(this.GrupoLista);
        //this.getTipoUsuario();
      });

  }
  /*
    UsuariosLista;
    Usuarios;
    getTipoUsuario()
    {
      this.spinner.show();
      this.tipoUsuarioService.getData().toPromise()
        .then(data => {
          this.Usuarios = data;
          //console.log(this.Usuarios)
          this.UsuariosLista = this.Usuarios.filter(x => x.planteles.includes(this.sitio));
          const unique = [...new Set(this.UsuariosLista.map(item => item.idGrupo))];
          //console.log(unique);
          this.GrupoLista = this.GrupoLista.filter(i => unique.includes(i.idGrupo));
  
          if(this.sitio==3){
            this.GrupoLista.push({estatus: true,
              icono: "book-open",
              idGrupo: 5,
              nombre: "Manual"})
          }
  
          console.log(this.GrupoLista)
          this.spinner.hide();
        })
    }  
  */
  UsuariosFiltrados;
  idGrupo;
  grupoDesc;
  @ViewChild('manual') manual: TemplateRef<any>;
  filtra(content, idGrupo) {
    let ruta = '';
    this.grupoDesc = this.GrupoLista.find(x => Number(x.idGrupo) === Number(this.idGrupo));
    switch (idGrupo) {
      case 5: ruta = 'usuario'; break;
      case 6: ruta = 'rol'; break;
      case 7: ruta = 'solicitud'; break;
      case 8: ruta = 'espaciotipo'; break;
      case 9: ruta = 'espacio'; break;
      case 10: ruta = 'equipo'; break;
      case 11: ruta = 'diainhabil'; break;
      case 12: ruta = 'usuario-tipo'; break;
      case 1002: ruta = 'reporte'; break;
      default: ruta = '';
    }

    this.router.navigate(['/' + ruta]);
    /*
    //Si es el manual, solo abrimos una nueva ventana
    if(idGrupo==5){
      //alert("manual");
      this.modal.open(this.manual, { size: 'xl' });
      return false;
    }

    this.idGrupo = idGrupo;
    this.grupoDesc = this.GrupoLista.find(x => Number(x.idGrupo) === Number(this.idGrupo)).descripcion;
    this.UsuariosFiltrados = this.UsuariosLista.filter(x => Number(x.idGrupo) === Number(this.idGrupo));

    //Si es personal o alumnado, ponemos estos grupos al inicio de los elementos
    if(idGrupo==1 || idGrupo==2){
      let first = 0;
      let data = this.UsuariosFiltrados;
      if(idGrupo==1) first = 24;
      if(idGrupo==2){
        first = 21;
        if(this.sitio==2) first = 34;
      } 
      

      data.unshift(data.splice(data.findIndex(item => item.idTipoUsuario === first), 1)[0])
      this.UsuariosFiltrados = data;      
    }
    this.rows();
    this.modal.open(content, { size: 'xl' });
    */
  }

  actRows;
  rows() {
    this.actRows = [];
    this.UsuariosFiltrados.forEach((item, index) => {
      if (index % 5 == 0) {
        let row = [];
        row.push(item);
        this.actRows.push(row);
      } else {
        this.actRows[this.actRows.length - 1].push(item);
      }
    });
  }

  //filtra(id){}
  //onSelect(id){}



  login(tipo) {
    //alert(tipo);
    this.modal.dismissAll();
    localStorage.setItem('usuarioGrupo', this.selectedUser.toString());
    localStorage.setItem('usuarioTipo', tipo);
    localStorage.setItem('usuarioSitio', this.sitio);
    localStorage.setItem('noredirect', '');
    if (tipo == 104 || tipo == 105 || tipo == 110) {
      this.router.navigate(['/guardia']);
    }
    else {
      this.router.navigate(['/login']);
    }

  }

  sitio;
  logo;
  bgapp;
  bgtext;
  getSitio(sitio) {
    //console.log();
    this.sitio = sitio;
    if (sitio == undefined) {
      this.sitio = this.usuarioService.getSitio();
    }

    this.bgapp = '';
    if (this.sitio == 1) { //1 - CDMX
      this.logo = 'ibero-090.svg';
      this.bgapp = 'bg-ibero-rojo';
      this.bgtext = '';
    }
    if (this.sitio == 2) { //2 - PREPA
      this.logo = 'logo-prepa.svg';
      this.bgapp = 'bg-ibero-rojo';
      this.bgtext = '';
    }
    if (this.sitio == 3) { //3 - TIJUANA
      this.logo = 'ibero-099.svg';
      this.bgapp = '';
      this.bgtext = 'text-ibero';
    }
  }

}
